import type { Item } from '@site-builder/store-sdk';

export const isItemPurchased = (item: Item): boolean => {
  const { canBeBought } = item;

  if (!canBeBought) {
    return true;
  }

  if (item.type === 'bundle' && 'limits' in item && item.limits?.perUser) {
    const { available } = item.limits.perUser;
    if (available === 0) {
      return true;
    }
  }

  return false;
};
